import { render, staticRenderFns } from "./VueAddress.vue?vue&type=template&id=968cabf8&scoped=true"
import script from "./VueAddress.vue?vue&type=script&lang=js"
export * from "./VueAddress.vue?vue&type=script&lang=js"
import style0 from "./VueAddress.vue?vue&type=style&index=0&id=968cabf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968cabf8",
  null
  
)

export default component.exports